import {Component, OnInit} from '@angular/core';
import {TranslateService} from 'bos-commons';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

  title = 'auth-project';

  constructor(private translateService: TranslateService) {

  }

  ngOnInit(): void {
    this.title = this.translateService.translateWithArgs('app.title')

  }
}
